import React from 'react';

const Button = ({ children, variant = 'default', disabled = false, ...props }) => {
  const baseStyles =
    'px-3 py-1.5 text-sm rounded-md font-semibold uppercase transition-transform transform inline-flex items-center justify-center';
  const hoverEffect = !disabled ? 'hover:scale-105 hover:shadow-md' : '';
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';

  const variantStyles = {
    default: 'bg-[#7CB342] text-white shadow-sm',
    cancel: 'border border-red-500 text-red-500 bg-transparent',
    gray: 'bg-gray-200 text-gray-800 hover:bg-gray-300 shadow-sm',
  };

  return (
    <button
      disabled={disabled}
      className={`${baseStyles} ${hoverEffect} ${variantStyles[variant] || variantStyles.default} ${disabledStyles}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
